import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {ST} from "../global/SystemText";

import {Session} from "../global/PortalTools";

export default class BiznisMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            expand: true,
            active:0
        }
    }

    handleMobileLeftMenu(){
        var evt = new CustomEvent('handleMobileLeftMenu');
        window.dispatchEvent(evt);
    }

    render() {

            return (

                <div className="sidebar-category">
                    <div onClick={()=>this.setState({expand:!this.state.expand})} className="category-title" style={{background:window.portalSettings.portal_pcolor+"0d"}}>
                        <span>{ST.get("business","global")}</span>
                        <ul className="icons-list">
                            <li><i onClick={()=>this.setState({expand:!this.state.expand})} className={"icon icon-chevron-"+ (this.state.expand?"up":"down") +" cursor-pointer"}/></li>
                        </ul>
                    </div>
                    <ul className="navigation navigation-alt navigation-accordion navigation-sm no-padding-top" style={!this.state.expand ? {display:"none"} : {}}>
                        <li onClick={()=>this.handleMobileLeftMenu()}>
                            {Number(window.portalSettings.quotation_access)>0?
                                <Link   to={Session.getItem("basename")+"/documents/quotation"}><i className="menu-icon icon-file-text2 v2-only"/>{ST.get("quotations_list","global")}</Link>:null}
                            {Number(window.portalSettings.orderin_access)>0?
                            <Link   to={Session.getItem("basename")+"/documents/orderin"}><i className="menu-icon icon-clipboard3 v2-only"/>{ST.get("orderins_list","global")}</Link>:null}
                            {Number(window.portalSettings.invoice_access)>0?
                            <Link   to={Session.getItem("basename")+"/documents/invoice"}><i className="menu-icon icon-coins v2-only"/>{ST.get("invoice_list","global")}</Link>:null}
                            {window.portalSettings.allow_claim?
                                <Link   to={Session.getItem("basename")+"/documents/claim"}><i className="menu-icon icon-lifebuoy v2-only"/>{ST.get("claim_list","global")}</Link>:null}
                            {Number(window.portalSettings.warehouse_access)>0?
                            <Link   to={Session.getItem("basename")+"/documents/warehouse"}><i className="menu-icon icon-truck v2-only"/>{ST.get("delivery_notes_list","global")}</Link>:null}
                            {Number(window.portalSettings.warehouse_access)>0 || window.localStorage.getItem("instance")==="pronar"?
                            <Link   to={Session.getItem("basename") + "/undelivered_products"}><i className="menu-icon icon-box v2-only"/>{ST.get("undelivered_products", "global")}</Link>:null}
                            {Number(window.portalSettings.service_access)>0 ?
                                <Link   to={Session.getItem("basename") + "/service"}><i className="menu-icon icon-wrench3 v2-only"/>{ST.get("serviceProduct", "service")}</Link>:null}
                            {window.portalSettings.dms_allow===true?
                            <Link   to={Session.getItem("basename")+"/dms"}><i className="menu-icon icon-file-download v2-only"/>{ST.get("for_download","global")}</Link>:null}
                            {window.portalSettings.allow_wishlist?
                                <Link   to={Session.getItem("basename")+"/wishlists"}><i className="menu-icon icon-heart5 v2-only"/>{ST.get("wishlists_list","global")}</Link>:null}
                        </li>
                    </ul>
                </div>
            );

    }
}
